// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"41":"befc3286","230":"b2adee2b","301":"f571c6c1","562":"fbb7c8e2","796":"a5eb80de","866":"d178157c","888":"16f95d5b"}[chunkId] + ".js";
};